import $ from 'jquery';
import Cookies from 'js-cookie';

if($("body.admin#list").length){

	if($("#expireImportBtn").length){
		const token = Cookies.get('XSRF-TOKEN');

		const expireImportBtn = document.getElementById("expireImportBtn");
		const expireImportInput = document.getElementById("expireImportInput");

		expireImportBtn.addEventListener("click", () => {
			expireImportInput.click();
		});

		expireImportInput.addEventListener("change", async () => {
			const file = expireImportInput.files[0];
			if (!file) return;
			expireImportInput.value = "";

			const formData = new FormData();
			formData.append("file", file);

			try {
				const res = await fetch("/admin/api/userExpireImport", {
					method: "POST",
					body: formData,
					headers: {
						'X-XSRF-TOKEN': token
					}
				});

				const data = await res.json();
				if(data.status == 1){
					alert("有効期限を更新しました");
				}else{
					alert("有効期限の更新に失敗しました。CSVのフォーマットを確認してください。");
				}
			} catch (err) {
				alert("有効期限の更新に失敗しました。CSVのフォーマットを確認してください。");
			}
		});
	}

	$("input[name='withdraw']").on("change", function(){
		$(this).closest("form").trigger("submit");
	});
}